define('services/common/ajax/PartnerMarketSOService',['app','mainCons'], function (app,mainCons) {
    app.factory('PartnerMarketSOService', ['auiAjaxWithError','$q','auiDialog','$filter',function (auiAjaxWithError,$q,auiDialog,$filter) {

        return {
            exportSettledOrderList:auiAjaxWithError.curryWithoutError('PartnerMarketSOService','PartnerMarketSOService.Developer.exportSettledOrderList')

        }
    }]);
});
